import Utils from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";
import { InfoWindow } from "./InfoWindow";

export class LungsText extends InfoWindow {
  shiftX = 350;
  shiftY = 100;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  get supportsForeignObject() {
    return typeof SVGForeignObjectElement !== "undefined";
  }

  getExtraData(patient: Patient) {
    const ventStatus = _.get(
      patient,
      "body.atoms.ventStatus.legend",
      ""
    ).replace(/(?:\r\n|\r|\n)/g, "|");
    this.linesToBold = [];
    ventStatus.split("|").forEach((status: string, index: number) => {
      if (status) {
        this.linesToBold.push(index);
      }
    });

    // let __ any must have same name as the atom
    let ventMode = _.get(patient, "body.atoms.ventMode.legend", null);
    ventMode = ventMode ? "Mode " + ventMode : ventMode;

    let lungRate = _.get(patient, "body.atoms.lungRate.legend", null);
    lungRate =
      lungRate && !lungRate.startsWith("RR") ? ["RR", lungRate] : lungRate;

    let pip = _.get(patient, "body.atoms.pip.legend", null);
    pip = pip ? ["PIP", pip] : pip;

    let peep = _.get(patient, "body.atoms.peep.legend", null);
    peep = peep ? ["PEEP", peep] : peep;

    let drivingPressure = _.get(
      patient,
      "body.atoms.drivingPressure.legend",
      null
    );
    drivingPressure = drivingPressure ? ["ΔP ", drivingPressure] : null;

    let tidalVolume = _.get(patient, "body.atoms.tidalVolume.legend", null);
    const tvName = this.supportsForeignObject ? "VT<sub>act</sub>" : "TVact";

    tidalVolume = tidalVolume
      ? [tvName, tidalVolume.replace("<br>", "|")]
      : tidalVolume;

    let lungCompliance = _.get(
      patient,
      "body.atoms.lungCompliance.legend",
      null
    );
    const lcName = this.supportsForeignObject ? "C<sub>dyn</sub>" : "Cdyn";
    lungCompliance = lungCompliance ? [lcName, lungCompliance] : null;

    let fiO2 = _.get(patient, "body.atoms.fiO2.legend", null);
    const fiName = this.supportsForeignObject ? "FiO<sub>2</sub>" : "FiO₂";
    fiO2 = fiO2 ? [fiName, fiO2] : fiO2;

    let nitricOxide = _.get(patient, "body.atoms.nitricOxide.legend", null);
    nitricOxide = nitricOxide ? ["NO", nitricOxide] : nitricOxide;

    let rsbi = _.get(patient, "body.atoms.rsbi.legend", null);
    rsbi = rsbi ? ["RSBI", rsbi] : rsbi;

    let pafi = _.get(patient, "body.atoms.pafi.legend", null);
    pafi = pafi ? ["P/F Ratio", pafi] : pafi;

    let onVent = _.get(patient, "body.atoms.ventStatus.age", -1) >= 0;
    let supplementalO2Rate = null;
    if (!onVent) {
      supplementalO2Rate = _.get(
        patient,
        "body.atoms.supplementalO2Rate.legend",
        null
      );
      const o2Name = this.supportsForeignObject ? "O<sub>2</sub>" : "O₂";
      supplementalO2Rate = supplementalO2Rate
        ? [o2Name, supplementalO2Rate]
        : null;
    }

    const dataToMap = {
      ventStatus,
      ventMode,
      lungRate,
      pip,
      peep,
      drivingPressure,
      tidalVolume,
      lungCompliance,
      fiO2,
      nitricOxide,
      rsbi,
      pafi,
      supplementalO2Rate
    };

    this.extraData = {
      tableData: Object.entries(dataToMap)
        .filter(([_key, item]) => {
          if (_.isArray(item)) {
            return item[1];
          } else {
            return item;
          }
        })
        .map(([key, item]) => {
          const level = _.get(patient, `body.atoms.${key}.level`);
          const color =
            level === 3 || level === 0
              ? ""
              : Utils.getLevelColor(level, this.showGreenGrayOnly);
          return { rows: item, color, level };
        })
    };
  }
}
